import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import { __awaiter, __extends, __generator } from "tslib";
import ProviderService from '@/modules/providers/ProviderService';
import { BaseStockModel } from '@/core/standard/BaseStockModel';
import SerialService from '@/modules/utilities/SerialService';
var provider = {
  name: '',
  phone: '',
  email: '',
  category: ''
};

var ProviderModel =
/** @class */
function (_super) {
  __extends(ProviderModel, _super);

  function ProviderModel() {
    var _this = _super.call(this, provider, ProviderService) || this;

    _this.modelName = 'Mesa';
    _this.request = 'FormData';
    return _this;
  }

  ProviderModel.prototype.create = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var serial, dataToSend, formData, query, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , SerialService.getSerial(JSON.stringify({
              module: 'providers'
            }))];

          case 1:
            serial = _a.sent().data;
            dataToSend = {};
            data.forEach(function (value, key) {
              dataToSend[key] = value;
            });
            formData = new FormData();
            Object.keys(dataToSend).forEach(function (key) {
              formData.append(key, dataToSend[key]);
            });
            formData.append('extras', "" + JSON.stringify({
              serial: serial
            }));
            query = {
              query: formData,
              method: 'POST'
            };
            return [4
            /*yield*/
            , this.service.insert(query)];

          case 2:
            response = _a.sent();

            if (response.complete) {
              return [2
              /*return*/
              , this.handleSuccess(response.data, 'Ok', null)];
            } else {
              this.handleError(response, toast, toastConfig);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return ProviderModel;
}(BaseStockModel);

export default ProviderModel;